/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandListItem
 */
export interface BrandListItem {
    /**
     * 
     * @type {number}
     * @memberof BrandListItem
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof BrandListItem
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof BrandListItem
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof BrandListItem
     */
    label?: string | null;
}

export function BrandListItemFromJSON(json: any): BrandListItem {
    return BrandListItemFromJSONTyped(json, false);
}

export function BrandListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function BrandListItemToJSON(value?: BrandListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'label': value.label,
    };
}


